'use client';

/**
 * RescueStats Component
 *
 * Displays key statistics about the Hall of Shame
 */
import { c as _c } from "react/compiler-runtime";
import { motion } from 'motion/react';
import { Skull, Layers, Coins } from 'lucide-react';
import { Skeleton } from '@heroui/react';
interface RescueStatsProps {
  totalProtocols: number;
  totalPools: number;
  userPositions: number;
  isLoading?: boolean;
}
export default function RescueStats(t0) {
  const $ = _c(5);
  const {
    totalProtocols,
    totalPools,
    userPositions,
    isLoading: t1
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== isLoading || $[1] !== totalPools || $[2] !== totalProtocols || $[3] !== userPositions) {
    const stats = [{
      label: "Dead Protocols",
      value: totalProtocols,
      icon: Skull,
      color: "text-danger",
      bgColor: "bg-danger/10",
      borderColor: "border-danger/30"
    }, {
      label: "Affected Pools",
      value: totalPools,
      icon: Layers,
      color: "text-warning",
      bgColor: "bg-warning/10",
      borderColor: "border-warning/30"
    }, {
      label: "Your Stuck Pools",
      value: userPositions,
      icon: Coins,
      color: userPositions > 0 ? "text-danger" : "text-success",
      bgColor: userPositions > 0 ? "bg-danger/10" : "bg-success/10",
      borderColor: userPositions > 0 ? "border-danger/30" : "border-success/30",
      highlight: userPositions > 0
    }];
    t2 = <div className="flex justify-center gap-4">{stats.map((stat, index) => <motion.div key={stat.label} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.1
      }} className={`
            relative flex flex-col items-center p-4 rounded-xl
            ${stat.bgColor} border ${stat.borderColor}
            min-w-[100px] transition-all
            ${stat.highlight ? "animate-pulse" : ""}
          `}><stat.icon className={`w-6 h-6 ${stat.color} mb-2`} />{isLoading ? <Skeleton className="w-12 h-8 rounded" /> : <span className={`text-2xl font-bold text-shadow-sm/50 ${stat.color}`}>{stat.value.toLocaleString()}</span>}<span className="text-xs text-foreground-700 text-center mt-1 text-shadow-sm/50">{stat.label}</span></motion.div>)}</div>;
    $[0] = isLoading;
    $[1] = totalPools;
    $[2] = totalProtocols;
    $[3] = userPositions;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}